import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCataloguePage, LazyCategoryPage, LazyCheckoutPage, LazyContentPage, LazyCreatePasswordPage, LazyDownloadsPage, LazyHomePage, LazyMustReadPage, LazyOrderConfirmationPage, LazyProductPage, LazyResetPasswordPage, LazyAccountAddressInformation, LazyAccountBusinessInformation, LazyAccountLayout, LazyAccountPersonalDetails, LazyAccountQuickLinks, LazyAccountSalesRepresentative, LazyAlgoliaTypes, LazyAuthenticationCreatePasswordFailure, LazyAuthenticationCreatePasswordSuccess, LazyAuthenticationPasswordField, LazyAuthenticationTitle, LazyAuthenticationTypes, LazyBasketItemSelector, LazyBasketPage, LazyBasketSummarySkeleton, LazyBasketCatalogue, LazyBasketDeliveryOptions, LazyBasketItem, LazyBasketLayout, LazyBasketOrderConfirmationDeliveryAddress, LazyBasketSparesItem, LazyBasketSummary, LazyBasketWholesaleQuickAdd, LazyBasketTypes, LazyCheckoutBasketTypeSection, LazyDigitalBrochuresActions, LazyDigitalBrochuresDropdown, LazyDigitalBrochuresItem, LazyDigitalBrochuresMobileDropdown, LazyDigitalBrochuresMobileFilters, LazyDigitalBrochuresPDFViewer, LazyFavouriteButton, LazyFavouriteButtonVariantsFavouritesButtonLarge, LazyFavouriteButtonVariantsFavouritesButtonSmall, LazyHeroCarouselDesktop, LazyHeroCarouselMobile, LazyHeroTypes, LazyInvoicesActions, LazyInvoicesFilters, LazyInvoicesList, LazyInvoicesPDFViewer, LazyNavigationAlgoliaSearchIcon, LazyNavigationFooter, LazyNavigationFooterSocialLink, LazyNavigationHeader, LazyNavigationHeaderBasketControls, LazyNavigationHeaderDropdowns, LazyNavigationHeaderDropdownsUnauthenticated, LazyNavigationMobileNavigation, LazyNavigationMobileNavigationFooter, LazyNavigationMobileNavigationMenu, LazyNavigationMobileNavigationSubMenu, LazyNavigation, LazyNavigationSubMenu, LazyNavigationTypes, LazyOrderHistoryActions, LazyOrderHistoryButtons, LazyOrderHistoryFilters, LazyOrderHistoryList, LazyOrderHistoryMobileDetail, LazyOrderHistoryTypes, LazyProductBreadCrumb, LazyProductCard, LazyProductCardCta, LazyProductConfigurator, LazyProductProductConfiguratorDescription, LazyProductProductConfiguratorDescriptionField, LazyProductProductConfiguratorDisplayText, LazyProductProductConfiguratorField, LazyProductProductConfiguratorFieldGroup, LazyProductProductConfiguratorFieldSkeleton, LazyProductProductConfiguratorHiddenField, LazyProductProductConfiguratorIconRadio, LazyProductProductConfiguratorJoinField, LazyProductProductConfiguratorKeyValueSection, LazyProductProductConfiguratorMeasurement, LazyProductProductConfiguratorRadio, LazyProductProductConfiguratorSelect, LazyProductProductConfiguratorSqmField, LazyProductProductConfiguratorText, LazyProductLayout, LazyProductMadeToMeasure, LazyProductMarketingMaterials, LazyProductPleatedBlinds, LazyProductPrice, LazyProductQuantity, LazyProductWholesale, LazyProductTypes, LazyProductWholesaleIconRadio, LazyProductWholesalePrice, LazyRelatedProductsAlgolia, LazyRelatedProductsOverride, LazyRelatedProducts, LazyRichTextEditorTypes, LazySearchAutoComplete, LazySearchFacetDropdown, LazySearchFacetDropdownMobile, LazySearchHeader, LazySearchHeaderDefaultHeader, LazySearchHeaderSearchResultsHeader, LazySearchHeaderSimpleHeader, LazySearchLoadingSkeleton, LazySearchMobileFilters, LazySearchPagination, LazySearchSortBy, LazySearchStats, LazySearchTypes, LazySiteWideMessagingItem, LazySiteWideMessagingRenderer, LazyStatementsFilters, LazyStatementsList, LazyStatementsPDFViewer, LazyStatementsTypes, LazyUnsubmittedLayout, LazyUnsubmittedFilters, LazyUnsubmittedList, LazyUsersAddUserModal, LazyUsersLayout, LazyUsersUserList, LazyAccordion, LazyAccordionTopics, LazyAlert, LazyBestSellers, LazyBreadcrumbs, LazyCarousel, LazyComponentRenderer, LazyFrequentlyBought, LazyHelpTextFlyout, LazyHero, LazyHeroCarousel, LazyImages, LazyInputError, LazyKeyValueTable, LazyLatestOffers, LazyLogos, LazyMediaWithText, LazyMobileMenu, LazyModal, LazyOverlayBlur, LazyProductCardCarousel, LazyProductCategoryCarousel, LazyQuickLinks, LazyRelatedLinks, LazyRichTextEditor, LazySiteWideMessaging, LazyTable, LazyTooltip, LazyVideo } from '#components'
const lazyGlobalComponents = [
  ["CataloguePage", LazyCataloguePage],
["CategoryPage", LazyCategoryPage],
["CheckoutPage", LazyCheckoutPage],
["ContentPage", LazyContentPage],
["CreatePasswordPage", LazyCreatePasswordPage],
["DownloadsPage", LazyDownloadsPage],
["HomePage", LazyHomePage],
["MustReadPage", LazyMustReadPage],
["OrderConfirmationPage", LazyOrderConfirmationPage],
["ProductPage", LazyProductPage],
["ResetPasswordPage", LazyResetPasswordPage],
["AccountAddressInformation", LazyAccountAddressInformation],
["AccountBusinessInformation", LazyAccountBusinessInformation],
["AccountLayout", LazyAccountLayout],
["AccountPersonalDetails", LazyAccountPersonalDetails],
["AccountQuickLinks", LazyAccountQuickLinks],
["AccountSalesRepresentative", LazyAccountSalesRepresentative],
["AlgoliaTypes", LazyAlgoliaTypes],
["AuthenticationCreatePasswordFailure", LazyAuthenticationCreatePasswordFailure],
["AuthenticationCreatePasswordSuccess", LazyAuthenticationCreatePasswordSuccess],
["AuthenticationPasswordField", LazyAuthenticationPasswordField],
["AuthenticationTitle", LazyAuthenticationTitle],
["AuthenticationTypes", LazyAuthenticationTypes],
["BasketItemSelector", LazyBasketItemSelector],
["BasketPage", LazyBasketPage],
["BasketSummarySkeleton", LazyBasketSummarySkeleton],
["BasketCatalogue", LazyBasketCatalogue],
["BasketDeliveryOptions", LazyBasketDeliveryOptions],
["BasketItem", LazyBasketItem],
["BasketLayout", LazyBasketLayout],
["BasketOrderConfirmationDeliveryAddress", LazyBasketOrderConfirmationDeliveryAddress],
["BasketSparesItem", LazyBasketSparesItem],
["BasketSummary", LazyBasketSummary],
["BasketWholesaleQuickAdd", LazyBasketWholesaleQuickAdd],
["BasketTypes", LazyBasketTypes],
["CheckoutBasketTypeSection", LazyCheckoutBasketTypeSection],
["DigitalBrochuresActions", LazyDigitalBrochuresActions],
["DigitalBrochuresDropdown", LazyDigitalBrochuresDropdown],
["DigitalBrochuresItem", LazyDigitalBrochuresItem],
["DigitalBrochuresMobileDropdown", LazyDigitalBrochuresMobileDropdown],
["DigitalBrochuresMobileFilters", LazyDigitalBrochuresMobileFilters],
["DigitalBrochuresPDFViewer", LazyDigitalBrochuresPDFViewer],
["FavouriteButton", LazyFavouriteButton],
["FavouriteButtonVariantsFavouritesButtonLarge", LazyFavouriteButtonVariantsFavouritesButtonLarge],
["FavouriteButtonVariantsFavouritesButtonSmall", LazyFavouriteButtonVariantsFavouritesButtonSmall],
["HeroCarouselDesktop", LazyHeroCarouselDesktop],
["HeroCarouselMobile", LazyHeroCarouselMobile],
["HeroTypes", LazyHeroTypes],
["InvoicesActions", LazyInvoicesActions],
["InvoicesFilters", LazyInvoicesFilters],
["InvoicesList", LazyInvoicesList],
["InvoicesPDFViewer", LazyInvoicesPDFViewer],
["NavigationAlgoliaSearchIcon", LazyNavigationAlgoliaSearchIcon],
["NavigationFooter", LazyNavigationFooter],
["NavigationFooterSocialLink", LazyNavigationFooterSocialLink],
["NavigationHeader", LazyNavigationHeader],
["NavigationHeaderBasketControls", LazyNavigationHeaderBasketControls],
["NavigationHeaderDropdowns", LazyNavigationHeaderDropdowns],
["NavigationHeaderDropdownsUnauthenticated", LazyNavigationHeaderDropdownsUnauthenticated],
["NavigationMobileNavigation", LazyNavigationMobileNavigation],
["NavigationMobileNavigationFooter", LazyNavigationMobileNavigationFooter],
["NavigationMobileNavigationMenu", LazyNavigationMobileNavigationMenu],
["NavigationMobileNavigationSubMenu", LazyNavigationMobileNavigationSubMenu],
["Navigation", LazyNavigation],
["NavigationSubMenu", LazyNavigationSubMenu],
["NavigationTypes", LazyNavigationTypes],
["OrderHistoryActions", LazyOrderHistoryActions],
["OrderHistoryButtons", LazyOrderHistoryButtons],
["OrderHistoryFilters", LazyOrderHistoryFilters],
["OrderHistoryList", LazyOrderHistoryList],
["OrderHistoryMobileDetail", LazyOrderHistoryMobileDetail],
["OrderHistoryTypes", LazyOrderHistoryTypes],
["ProductBreadCrumb", LazyProductBreadCrumb],
["ProductCard", LazyProductCard],
["ProductCardCta", LazyProductCardCta],
["ProductConfigurator", LazyProductConfigurator],
["ProductProductConfiguratorDescription", LazyProductProductConfiguratorDescription],
["ProductProductConfiguratorDescriptionField", LazyProductProductConfiguratorDescriptionField],
["ProductProductConfiguratorDisplayText", LazyProductProductConfiguratorDisplayText],
["ProductProductConfiguratorField", LazyProductProductConfiguratorField],
["ProductProductConfiguratorFieldGroup", LazyProductProductConfiguratorFieldGroup],
["ProductProductConfiguratorFieldSkeleton", LazyProductProductConfiguratorFieldSkeleton],
["ProductProductConfiguratorHiddenField", LazyProductProductConfiguratorHiddenField],
["ProductProductConfiguratorIconRadio", LazyProductProductConfiguratorIconRadio],
["ProductProductConfiguratorJoinField", LazyProductProductConfiguratorJoinField],
["ProductProductConfiguratorKeyValueSection", LazyProductProductConfiguratorKeyValueSection],
["ProductProductConfiguratorMeasurement", LazyProductProductConfiguratorMeasurement],
["ProductProductConfiguratorRadio", LazyProductProductConfiguratorRadio],
["ProductProductConfiguratorSelect", LazyProductProductConfiguratorSelect],
["ProductProductConfiguratorSqmField", LazyProductProductConfiguratorSqmField],
["ProductProductConfiguratorText", LazyProductProductConfiguratorText],
["ProductLayout", LazyProductLayout],
["ProductMadeToMeasure", LazyProductMadeToMeasure],
["ProductMarketingMaterials", LazyProductMarketingMaterials],
["ProductPleatedBlinds", LazyProductPleatedBlinds],
["ProductPrice", LazyProductPrice],
["ProductQuantity", LazyProductQuantity],
["ProductWholesale", LazyProductWholesale],
["ProductTypes", LazyProductTypes],
["ProductWholesaleIconRadio", LazyProductWholesaleIconRadio],
["ProductWholesalePrice", LazyProductWholesalePrice],
["RelatedProductsAlgolia", LazyRelatedProductsAlgolia],
["RelatedProductsOverride", LazyRelatedProductsOverride],
["RelatedProducts", LazyRelatedProducts],
["RichTextEditorTypes", LazyRichTextEditorTypes],
["SearchAutoComplete", LazySearchAutoComplete],
["SearchFacetDropdown", LazySearchFacetDropdown],
["SearchFacetDropdownMobile", LazySearchFacetDropdownMobile],
["SearchHeader", LazySearchHeader],
["SearchHeaderDefaultHeader", LazySearchHeaderDefaultHeader],
["SearchHeaderSearchResultsHeader", LazySearchHeaderSearchResultsHeader],
["SearchHeaderSimpleHeader", LazySearchHeaderSimpleHeader],
["SearchLoadingSkeleton", LazySearchLoadingSkeleton],
["SearchMobileFilters", LazySearchMobileFilters],
["SearchPagination", LazySearchPagination],
["SearchSortBy", LazySearchSortBy],
["SearchStats", LazySearchStats],
["SearchTypes", LazySearchTypes],
["SiteWideMessagingItem", LazySiteWideMessagingItem],
["SiteWideMessagingRenderer", LazySiteWideMessagingRenderer],
["StatementsFilters", LazyStatementsFilters],
["StatementsList", LazyStatementsList],
["StatementsPDFViewer", LazyStatementsPDFViewer],
["StatementsTypes", LazyStatementsTypes],
["UnsubmittedLayout", LazyUnsubmittedLayout],
["UnsubmittedFilters", LazyUnsubmittedFilters],
["UnsubmittedList", LazyUnsubmittedList],
["UsersAddUserModal", LazyUsersAddUserModal],
["UsersLayout", LazyUsersLayout],
["UsersUserList", LazyUsersUserList],
["Accordion", LazyAccordion],
["AccordionTopics", LazyAccordionTopics],
["Alert", LazyAlert],
["BestSellers", LazyBestSellers],
["Breadcrumbs", LazyBreadcrumbs],
["Carousel", LazyCarousel],
["ComponentRenderer", LazyComponentRenderer],
["FrequentlyBought", LazyFrequentlyBought],
["HelpTextFlyout", LazyHelpTextFlyout],
["Hero", LazyHero],
["HeroCarousel", LazyHeroCarousel],
["Images", LazyImages],
["InputError", LazyInputError],
["KeyValueTable", LazyKeyValueTable],
["LatestOffers", LazyLatestOffers],
["Logos", LazyLogos],
["MediaWithText", LazyMediaWithText],
["MobileMenu", LazyMobileMenu],
["Modal", LazyModal],
["OverlayBlur", LazyOverlayBlur],
["ProductCardCarousel", LazyProductCardCarousel],
["ProductCategoryCarousel", LazyProductCategoryCarousel],
["QuickLinks", LazyQuickLinks],
["RelatedLinks", LazyRelatedLinks],
["RichTextEditor", LazyRichTextEditor],
["SiteWideMessaging", LazySiteWideMessaging],
["Table", LazyTable],
["Tooltip", LazyTooltip],
["Video", LazyVideo],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
